import { type PromoType } from '@hungryroot/rest/api/get_pricing_config/get';

export interface PromoValue {
  value?: null | number;
  isExpired: boolean;
  type: PromoType;
  label: string;
  code: string;
  threshold: number;
}

export const getPromoForOverlay = (
  subtotal: number,
  effectBase?: string,
  promo?: PromoValue,
  cyoPromo?: PromoValue
) => {
  if (promo && subtotal >= promo?.threshold) {
    return effectBase;
  } else if (cyoPromo) {
    return `Free ${cyoPromo.label}`;
  }
  return '';
};
